/** Must stay in sync with `BlackoutPeriodController` in weborion-monitor-api. */
export const MAX_RECURRING_PERIODS = 366;

export const MAX_RECURRING_BLACKOUT_ROWS = 20000;

export const BLACKOUT_MODE = {
  ONCE: 'once',
  REPEATING: 'repeating',
};

export const BLACKOUT_FREQUENCY = {
  DAILY: 'daily',
  WEEKLY: 'weekly',
  MONTHLY: 'monthly',
};

export const BlackoutModes = [
  { value: BLACKOUT_MODE.ONCE, label: 'Once' },
  { value: BLACKOUT_MODE.REPEATING, label: 'Repeating' },
];

export const BlackoutFrequencies = [
  { value: BLACKOUT_FREQUENCY.DAILY, label: 'Daily' },
  { value: BLACKOUT_FREQUENCY.WEEKLY, label: 'Weekly' },
  { value: BLACKOUT_FREQUENCY.MONTHLY, label: 'Monthly' },
];

/** Status labels aligned with `BlackoutPeriodController::groupBlackoutUrlEntries`. */
export const BLACKOUT_URL_STATUS = {
  AWAITING: 'Awaiting',
  IN_PROGRESS: 'In Progress',
  EXPIRED: 'Expired',
  NONE: 'No blackout',
};

export const BlackoutUrlStatusFilterOptions = [
  { value: BLACKOUT_URL_STATUS.AWAITING, label: 'Awaiting' },
  { value: BLACKOUT_URL_STATUS.IN_PROGRESS, label: 'In Progress' },
  { value: BLACKOUT_URL_STATUS.EXPIRED, label: 'Expired' },
  { value: BLACKOUT_URL_STATUS.NONE, label: 'No blackout' },
];

export const DEFAULT_BLACKOUT_URL_STATUS_FILTERS = BlackoutUrlStatusFilterOptions.map((o) => o.value);

/** CSS class suffix for `.status` tags (see `_blackout-status-tags.scss`). */
export const BLACKOUT_STATUS_TAG_CLASS = {
  [BLACKOUT_URL_STATUS.AWAITING]: 'awaiting',
  [BLACKOUT_URL_STATUS.IN_PROGRESS]: 'progress',
  [BLACKOUT_URL_STATUS.EXPIRED]: 'expired',
  [BLACKOUT_URL_STATUS.NONE]: 'no-blackout',
};

export function getBlackoutStatusTagClass(statusLabel) {
  return BLACKOUT_STATUS_TAG_CLASS[statusLabel] || '';
}

export const DaysOfWeek = [
  { value: 0, label: 'Sunday' },
  { value: 1, label: 'Monday' },
  { value: 2, label: 'Tuesday' },
  { value: 3, label: 'Wednesday' },
  { value: 4, label: 'Thursday' },
  { value: 5, label: 'Friday' },
  { value: 6, label: 'Saturday' },
];

/**
 * Daily span in minutes (1 min – 24 h). End before start on the clock rolls to the next day.
 */
export function dailySpanMinutes(startTime, endTime) {
  if (!startTime || !endTime) return 0;
  const startMins = timeToMinutes(startTime);
  let endMins = timeToMinutes(endTime);
  if (endMins <= startMins) {
    endMins += 24 * 60;
  }
  return endMins - startMins;
}

/**
 * Weekly span in minutes (1 min – 7 days). Used for client-side validation.
 */
export function weeklySpanMinutes(startDow, endDow, startTime, endTime) {
  if (!startTime || !endTime) return 0;
  const startMins = timeToMinutes(startTime);
  const endMins = timeToMinutes(endTime);
  let startOffset = startDow * 1440 + startMins;
  let endOffset = endDow * 1440 + endMins;
  if (endOffset <= startOffset) endOffset += 7 * 1440;
  return endOffset - startOffset;
}

/**
 * Monthly span in minutes (1 min – 31 days). Used for client-side validation.
 */
export function monthlySpanMinutes(startDom, endDom, startTime, endTime) {
  if (!startTime || !endTime) return 0;
  const startMins = timeToMinutes(startTime);
  const endMins = timeToMinutes(endTime);
  let startOffset = (startDom - 1) * 1440 + startMins;
  let endOffset = (endDom - 1) * 1440 + endMins;
  if (endOffset <= startOffset) endOffset += 31 * 1440;
  return endOffset - startOffset;
}

function timeToMinutes(timeMoment) {
  if (timeMoment && typeof timeMoment.format === 'function') {
    const parts = timeMoment.format('HH:mm').split(':');
    return parseInt(parts[0], 10) * 60 + parseInt(parts[1], 10);
  }
  return 0;
}
